export default {
    props: {
        content: {
            type: Object|Array,
            required: false
        },
            pages: {
            type: Object|Array,
            required: false
        }
    },
    methods: {
        getPageSlugByLayout(layoutName, fallback = null) {
            return this.pages.find(page => page.layout_name === layoutName).slug || fallback || layoutName;
        }
    }
}
